import { STYLE_OPTIONS } from '../constants/hsCta';
export const nodeIsCtaPlaceholder = (editor, node) => editor.dom.is(node, `img[data-hs-cta-img]`);
export const updateCtaAlignment = (selectedNode, editor, newAlignment) => {
  editor.undoManager.transact(() => {
    const previousAlignment = selectedNode.getAttribute('data-hs-cta-style');
    selectedNode.removeAttribute('style');
    selectedNode.removeAttribute('data-hs-cta-style');
    const ctaStyles = STYLE_OPTIONS[newAlignment];
    if (ctaStyles && newAlignment !== previousAlignment) {
      selectedNode.setAttribute('data-hs-cta-style', newAlignment);
      editor.dom.setStyles(selectedNode, ctaStyles);
    }
  });
};
export const getGUID = selectedNode => {
  return (selectedNode.getAttribute('data-hs-img-pg') || selectedNode.getAttribute('id') || '').replace('hs-cta-img-', '');
};